export const SET_PARTNER_PRODUCTS = "SET_PARTNER_PRODUCTS";
export const SET_CREATED_PARTNER_PRODUCT = "SET_CREATED_PARTNER_PRODUCT";
export const SET_UPDATED_PARTNER_PRODUCT = "SET_UPDATED_PARTNER_PRODUCT";
export const REMOVE_DELETED_PARTNER_PRODUCT = "REMOVE_DELETED_PARTNER_PRODUCT";
export const SET_PARTNER_PRODUCT_ERROR = "SET_PARTNER_PRODUCT_ERROR";
export const SET_PARTNER_PRODUCTS_LOADING = "SET_PARTNER_PRODUCTS_LOADING";
export const SET_PARTNER_PRODUCTS_FETCHING = "SET_PARTNER_PRODUCTS_FETCHING";
